/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getUser = /* GraphQL */ `
  query GetUser($id: ID!) {
    getUser(id: $id) {
      id
      owner
      name
      description
      address
      website
      profileImage {
        name
        key
        url
      }
      locationId
      location {
        id
        owner
        name
        zip
        address1
        address2
        address3
        user {
          id
          owner
          name
          description
          address
          website
          profileImage {
            name
            key
            url
          }
          locationId
          location {
            id
            owner
            name
            zip
            address1
            address2
            address3
            createdAt
            updatedAt
            locationUserId
          }
          materials {
            nextToken
          }
          createdAt
          updatedAt
        }
        materials {
          items {
            id
            owner
            title
            description
            woodType
            kind
            price
            characters
            thicknesses
            finishes
            dryingMethods
            isOnSale
            createdAt
            updatedAt
            userMaterialsId
            locationMaterialsId
          }
          nextToken
        }
        createdAt
        updatedAt
        locationUserId
      }
      materials {
        items {
          id
          owner
          title
          description
          woodType
          kind
          price
          characters
          size {
            x
            y
            z
          }
          thicknesses
          finishes
          dryingMethods
          originalImage {
            name
            key
            url
          }
          scannedImage {
            name
            key
            url
          }
          dxfFile {
            name
            key
            url
          }
          images {
            name
            key
            url
          }
          isOnSale
          user {
            id
            owner
            name
            description
            address
            website
            locationId
            createdAt
            updatedAt
          }
          location {
            id
            owner
            name
            zip
            address1
            address2
            address3
            createdAt
            updatedAt
            locationUserId
          }
          comments {
            nextToken
          }
          createdAt
          updatedAt
          userMaterialsId
          locationMaterialsId
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const listUsers = /* GraphQL */ `
  query ListUsers(
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        name
        description
        address
        website
        profileImage {
          name
          key
          url
        }
        locationId
        location {
          id
          owner
          name
          zip
          address1
          address2
          address3
          user {
            id
            owner
            name
            description
            address
            website
            locationId
            createdAt
            updatedAt
          }
          materials {
            nextToken
          }
          createdAt
          updatedAt
          locationUserId
        }
        materials {
          items {
            id
            owner
            title
            description
            woodType
            kind
            price
            characters
            thicknesses
            finishes
            dryingMethods
            isOnSale
            createdAt
            updatedAt
            userMaterialsId
            locationMaterialsId
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getLocation = /* GraphQL */ `
  query GetLocation($id: ID!) {
    getLocation(id: $id) {
      id
      owner
      name
      zip
      address1
      address2
      address3
      user {
        id
        owner
        name
        description
        address
        website
        profileImage {
          name
          key
          url
        }
        locationId
        location {
          id
          owner
          name
          zip
          address1
          address2
          address3
          user {
            id
            owner
            name
            description
            address
            website
            locationId
            createdAt
            updatedAt
          }
          materials {
            nextToken
          }
          createdAt
          updatedAt
          locationUserId
        }
        materials {
          items {
            id
            owner
            title
            description
            woodType
            kind
            price
            characters
            thicknesses
            finishes
            dryingMethods
            isOnSale
            createdAt
            updatedAt
            userMaterialsId
            locationMaterialsId
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      materials {
        items {
          id
          owner
          title
          description
          woodType
          kind
          price
          characters
          size {
            x
            y
            z
          }
          thicknesses
          finishes
          dryingMethods
          originalImage {
            name
            key
            url
          }
          scannedImage {
            name
            key
            url
          }
          dxfFile {
            name
            key
            url
          }
          images {
            name
            key
            url
          }
          isOnSale
          user {
            id
            owner
            name
            description
            address
            website
            locationId
            createdAt
            updatedAt
          }
          location {
            id
            owner
            name
            zip
            address1
            address2
            address3
            createdAt
            updatedAt
            locationUserId
          }
          comments {
            nextToken
          }
          createdAt
          updatedAt
          userMaterialsId
          locationMaterialsId
        }
        nextToken
      }
      createdAt
      updatedAt
      locationUserId
    }
  }
`;
export const listLocations = /* GraphQL */ `
  query ListLocations(
    $filter: ModelLocationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLocations(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        name
        zip
        address1
        address2
        address3
        user {
          id
          owner
          name
          description
          address
          website
          profileImage {
            name
            key
            url
          }
          locationId
          location {
            id
            owner
            name
            zip
            address1
            address2
            address3
            createdAt
            updatedAt
            locationUserId
          }
          materials {
            nextToken
          }
          createdAt
          updatedAt
        }
        materials {
          items {
            id
            owner
            title
            description
            woodType
            kind
            price
            characters
            thicknesses
            finishes
            dryingMethods
            isOnSale
            createdAt
            updatedAt
            userMaterialsId
            locationMaterialsId
          }
          nextToken
        }
        createdAt
        updatedAt
        locationUserId
      }
      nextToken
    }
  }
`;
export const getMaterial = /* GraphQL */ `
  query GetMaterial($id: ID!) {
    getMaterial(id: $id) {
      id
      owner
      title
      description
      woodType
      kind
      price
      characters
      size {
        x
        y
        z
      }
      thicknesses
      finishes
      dryingMethods
      originalImage {
        name
        key
        url
      }
      scannedImage {
        name
        key
        url
      }
      dxfFile {
        name
        key
        url
      }
      images {
        name
        key
        url
      }
      isOnSale
      user {
        id
        owner
        name
        description
        address
        website
        profileImage {
          name
          key
          url
        }
        locationId
        location {
          id
          owner
          name
          zip
          address1
          address2
          address3
          user {
            id
            owner
            name
            description
            address
            website
            locationId
            createdAt
            updatedAt
          }
          materials {
            nextToken
          }
          createdAt
          updatedAt
          locationUserId
        }
        materials {
          items {
            id
            owner
            title
            description
            woodType
            kind
            price
            characters
            thicknesses
            finishes
            dryingMethods
            isOnSale
            createdAt
            updatedAt
            userMaterialsId
            locationMaterialsId
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      location {
        id
        owner
        name
        zip
        address1
        address2
        address3
        user {
          id
          owner
          name
          description
          address
          website
          profileImage {
            name
            key
            url
          }
          locationId
          location {
            id
            owner
            name
            zip
            address1
            address2
            address3
            createdAt
            updatedAt
            locationUserId
          }
          materials {
            nextToken
          }
          createdAt
          updatedAt
        }
        materials {
          items {
            id
            owner
            title
            description
            woodType
            kind
            price
            characters
            thicknesses
            finishes
            dryingMethods
            isOnSale
            createdAt
            updatedAt
            userMaterialsId
            locationMaterialsId
          }
          nextToken
        }
        createdAt
        updatedAt
        locationUserId
      }
      comments {
        items {
          id
          owner
          content
          material {
            id
            owner
            title
            description
            woodType
            kind
            price
            characters
            thicknesses
            finishes
            dryingMethods
            isOnSale
            createdAt
            updatedAt
            userMaterialsId
            locationMaterialsId
          }
          createdAt
          updatedAt
          materialCommentsId
        }
        nextToken
      }
      createdAt
      updatedAt
      userMaterialsId
      locationMaterialsId
    }
  }
`;
export const listMaterials = /* GraphQL */ `
  query ListMaterials(
    $filter: ModelMaterialFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMaterials(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        title
        description
        woodType
        kind
        price
        characters
        size {
          x
          y
          z
        }
        thicknesses
        finishes
        dryingMethods
        originalImage {
          name
          key
          url
        }
        scannedImage {
          name
          key
          url
        }
        dxfFile {
          name
          key
          url
        }
        images {
          name
          key
          url
        }
        isOnSale
        user {
          id
          owner
          name
          description
          address
          website
          profileImage {
            name
            key
            url
          }
          locationId
          location {
            id
            owner
            name
            zip
            address1
            address2
            address3
            createdAt
            updatedAt
            locationUserId
          }
          materials {
            nextToken
          }
          createdAt
          updatedAt
        }
        location {
          id
          owner
          name
          zip
          address1
          address2
          address3
          user {
            id
            owner
            name
            description
            address
            website
            locationId
            createdAt
            updatedAt
          }
          materials {
            nextToken
          }
          createdAt
          updatedAt
          locationUserId
        }
        comments {
          items {
            id
            owner
            content
            createdAt
            updatedAt
            materialCommentsId
          }
          nextToken
        }
        createdAt
        updatedAt
        userMaterialsId
        locationMaterialsId
      }
      nextToken
    }
  }
`;
export const getComment = /* GraphQL */ `
  query GetComment($id: ID!) {
    getComment(id: $id) {
      id
      owner
      content
      material {
        id
        owner
        title
        description
        woodType
        kind
        price
        characters
        size {
          x
          y
          z
        }
        thicknesses
        finishes
        dryingMethods
        originalImage {
          name
          key
          url
        }
        scannedImage {
          name
          key
          url
        }
        dxfFile {
          name
          key
          url
        }
        images {
          name
          key
          url
        }
        isOnSale
        user {
          id
          owner
          name
          description
          address
          website
          profileImage {
            name
            key
            url
          }
          locationId
          location {
            id
            owner
            name
            zip
            address1
            address2
            address3
            createdAt
            updatedAt
            locationUserId
          }
          materials {
            nextToken
          }
          createdAt
          updatedAt
        }
        location {
          id
          owner
          name
          zip
          address1
          address2
          address3
          user {
            id
            owner
            name
            description
            address
            website
            locationId
            createdAt
            updatedAt
          }
          materials {
            nextToken
          }
          createdAt
          updatedAt
          locationUserId
        }
        comments {
          items {
            id
            owner
            content
            createdAt
            updatedAt
            materialCommentsId
          }
          nextToken
        }
        createdAt
        updatedAt
        userMaterialsId
        locationMaterialsId
      }
      createdAt
      updatedAt
      materialCommentsId
    }
  }
`;
export const listComments = /* GraphQL */ `
  query ListComments(
    $filter: ModelCommentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listComments(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        content
        material {
          id
          owner
          title
          description
          woodType
          kind
          price
          characters
          size {
            x
            y
            z
          }
          thicknesses
          finishes
          dryingMethods
          originalImage {
            name
            key
            url
          }
          scannedImage {
            name
            key
            url
          }
          dxfFile {
            name
            key
            url
          }
          images {
            name
            key
            url
          }
          isOnSale
          user {
            id
            owner
            name
            description
            address
            website
            locationId
            createdAt
            updatedAt
          }
          location {
            id
            owner
            name
            zip
            address1
            address2
            address3
            createdAt
            updatedAt
            locationUserId
          }
          comments {
            nextToken
          }
          createdAt
          updatedAt
          userMaterialsId
          locationMaterialsId
        }
        createdAt
        updatedAt
        materialCommentsId
      }
      nextToken
    }
  }
`;
